export default __webpack_public_path__ + "static/media/frame3.cccb8862.png";